export const Lokesh_Second_Data = [{
    id: 19,
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/D44788/cremaffin-trial-stick-pack-of-15ml-pack-of-5-mint-2-1651912372.jpg",
    title: "Cremaffin Trial Stick Pack Of 15ml (Pack Of 2)",
    mrp: 59,
    strike: 70,
    discount: 15,
  },
  {
    id: 20,
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/J78271/dr-morepen-garcinia-cambogia-for-weight-loss-800mg-with-60-hca-60-capsules-2-1641793812.jpg",
    title: "Dr Morepen Garcinia Cambogia For Weight Gain",
    mrp: 449,
    strike: 899,
    discount: 50,
  },
  {
    title:
      "Venusia Max Intensive Moisturizing Lotion, Repairs Dry Skin, Provides Soft & Smooth Skin, 300gm",
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/263100/venusia-max-intensive-moisturizing-lotion-repairs-dry-skin-provides-soft-smooth-skin-300gm-2-1645786251.jpg",
    img2: "https://cdn01.pharmeasy.in/dam/products_otc/263100/venusia-max-intensive-moisturizing-lotion-repairs-dry-skin-provides-soft-smooth-skin-300gm-6.1-1645786158.jpg?dim=100x0&dpr=1&q=100",
    img3: "https://cdn01.pharmeasy.in/dam/products_otc/263100/venusia-max-intensive-moisturizing-lotion-repairs-dry-skin-provides-soft-smooth-skin-300gm-6.2-1645786155.jpg",
    mrp: 427.07,
    strike: 500,
    discount: 73,
    ancestor: [
      "All Categories",
      "Skin Care",
      "Skin Creams & Hair Removal",
      "Face Wipes",
    ],
    brand: "N/A",
    instock: true,
  },
  {
    title: "Ethiglo Skin Whitening Face Wash-70 Gm",
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/245780/ethiglo-skin-whitening-face-wash-70-gm-1-1641398620.jpg",
    img2: "https://cdn01.pharmeasy.in/dam/products_otc/245780/ethiglo-skin-whitening-face-wash-70-gm-2-1654078683.jpg?dim=100x0&dpr=1&q=100",
    img3: "https://cdn01.pharmeasy.in/dam/products_otc/245780/ethiglo-skin-whitening-face-wash-70-gm-3-1654078127.jpg?dim=100x0&dpr=1&q=100",
    mrp: 180,
    strike: 200,
    discount: 20,
    ancestor: [
      "All Categories",
      "Skin Care",
      "Skin Creams & Hair Removal",
      "Face Wipes",
    ],
    brand: "N/A",
    instock: true,
  },
  {
    title: "Episoft Cleansing Lotion 250ml",
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/273329/episoft-cleansing-lotion-250ml-2-1641398639.jpg?dim=320x320&dpr=1&q=100",
    img2: "https://cdn01.pharmeasy.in/dam/products_otc/273329/episoft-cleansing-lotion-250ml-6.1-1641398642.jpg?dim=100x0&dpr=1&q=100",
    img3: "https://cdn01.pharmeasy.in/dam/products_otc/273329/episoft-cleansing-lotion-250ml-7-1641398638.jpg?dim=100x0&dpr=1&q=100",
    mrp: 400,
    strike: 500,
    discount: 100,
    ancestor: ["All Categories", "Skin Care", "Skin Creams & Hair Removal"],
    brand: "N/A",
    instock: true,
  },
  {
    title:
      "Veet Pure Hair Removal Cream For Women With No Ammonia Smell, Sensitive Skin - 50 G",
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/I40181/veet-pure-hair-removal-cream-for-women-with-no-ammonia-smell-sensitive-skin-50-g-2-1656923330.jpg",
    img2: "https://cdn01.pharmeasy.in/dam/products_otc/I40181/veet-pure-hair-removal-cream-for-women-with-no-ammonia-smell-sensitive-skin-50-g-6.1-1656923502.jpg?dim=100x0&dpr=1&q=100",
    img3: "https://cdn01.pharmeasy.in/dam/products_otc/I40181/veet-pure-hair-removal-cream-for-women-with-no-ammonia-smell-sensitive-skin-50-g-6.2-1656923552.jpg?dim=100x0&dpr=1&q=100",
    mrp: 120,
    strike: 135,
    discount: 15,
    ancestor: ["All Categories", "Skin Care", "Skin Creams & Hair Removal"],
    brand: "N/A",
    instock: true,
  },
  {
    title: "Nivea Aloe Mosturizing Creme Bottle Of 200 Ml",
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/I40908/nivea-aloe-mosturizing-creme-bottle-of-200-ml-2-1654251202.jpg",
    img2: "https://cdn01.pharmeasy.in/dam/products_otc/I40908/nivea-aloe-mosturizing-creme-bottle-of-200-ml-3-1654251081.jpg?dim=100x0&dpr=1&q=100",
    img3: "https://cdn01.pharmeasy.in/dam/products_otc/I40908/nivea-aloe-mosturizing-creme-bottle-of-200-ml-6.1-1641788074.jpg?dim=100x0&dpr=1&q=100",
    mrp: 255,
    strike: 300,
    discount: 45,
    ancestor: ["All Categories", "Skin Care", "Skin Creams & Hair Removal"],
    brand: "N/A",
    instock: true,
  },
  {
    title: "La Shield Fisico Sunscreen Spf 50 Matte Tube Of 50 G",
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/239792/la-shield-spf-40-sunscreen-gel-50gm-2-1655119017.jpg?dim=320x320&dpr=1&q=100",
    img2: "https://cdn01.pharmeasy.in/dam/products_otc/O15703/la-shield-fisico-sunscreen-spf-50-matte-tube-of-50-g-6.1-1655118974.jpg?dim=100x0&dpr=1&q=100",
    img3: "https://cdn01.pharmeasy.in/dam/products_otc/O15703/la-shield-fisico-sunscreen-spf-50-matte-tube-of-50-g-6.4-1655118889.jpg?dim=100x0&dpr=1&q=100",
    mrp: 504,
    strike: 630,
    discount: 126,
    ancestor: ["All Categories", "Skin Care", "Skin Creams & Hair Removal"],
    brand: "N/A",
    instock: true,
  },
  {
    title:
      "Dettol Intense Cool Bathing Soap Bar With Menthol- Buy 4 Get 1 Free - 125g Each",
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/R85254/dettol-intense-cool-bathing-soap-bar-with-menthol-buy-4-get-1-free-125g-each-2-1656923385.jpg?dim=320x320&dpr=1&q=100",
    img2: "https://cdn01.pharmeasy.in/dam/products_otc/R85254/dettol-intense-cool-bathing-soap-bar-with-menthol-buy-4-get-1-free-125g-each-6.1-1656923359.jpg?dim=100x0&dpr=1&q=100",
    img3: "https://cdn01.pharmeasy.in/dam/products_otc/R85254/dettol-intense-cool-bathing-soap-bar-with-menthol-buy-4-get-1-free-125g-each-6.6-1656923378.jpg?dim=100x0&dpr=1&q=100",
    mrp: 250,
    strike: 300,
    discount: 50,
    ancestor: ["All Categories", "Skin Care", "Skin Creams & Hair Removal"],
    brand: "N/A",
    instock: true,
  },
  {
    title:
      "Lacto Calamine Daily Cleansing Face Wipes With Aloe Vera Cucumber And Vitamin E - 25 Wipes",
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/S78152/lacto-calamine-daily-cleansing-face-wipes-with-aloe-vera-cucumber-and-vitamin-e-25-wipes-2-1649841683.jpg?dim=320x320&dpr=1&q=100",
    img2: "https://cdn01.pharmeasy.in/dam/products_otc/S78152/lacto-calamine-daily-cleansing-face-wipes-with-aloe-vera-cucumber-and-vitamin-e-25-wipes-6.1-1649841745.jpg?dim=100x0&dpr=1&q=100",
    img3: "https://cdn01.pharmeasy.in/dam/products_otc/S78152/lacto-calamine-daily-cleansing-face-wipes-with-aloe-vera-cucumber-and-vitamin-e-25-wipes-6.2-1649841685.jpg?dim=100x0&dpr=1&q=100",
    mrp: 66,
    strike: 150,
    discount: 84,
    ancestor: [
      "All Categories",
      "Skin Care",
      "Skin Creams & Hair Removal",
      "Face Wipes",
    ],
    brand: "N/A",
    instock: true,
  },
  {
    title: "Baby Dove Rich Moisture Wipes 50 Pcs",
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/I07151/baby-dove-rich-moisture-wipes-50-pcs-2-1641787610.jpg",
    img2: "https://cdn01.pharmeasy.in/dam/products_otc/I07151/baby-dove-rich-moisture-wipes-50-pcs-6.1-1641787609.jpg?dim=100x0&dpr=1&q=100",
    img3: "https://cdn01.pharmeasy.in/dam/products_otc/I07151/baby-dove-rich-moisture-wipes-50-pcs-6.2-1641787610.jpg?dim=100x0&dpr=1&q=100",
    mrp: 122,
    strike: 135,
    discount: 13,
    ancestor: [
      "All Categories",
      "Skin Care",
      "Skin Creams & Hair Removal",
      "Face Wipes",
    ],
    brand: "N/A",
    instock: true,
  },
  {
    title: "D Acne Soft Foaming Face Wash Tube Of 100 G",
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/I07034/fash-x-gel-face-wash-200gm-2-1654167900.jpg?dim=320x320&dpr=1&q=100",
    img2: "https://cdn01.pharmeasy.in/dam/products_otc/I07034/fash-x-gel-face-wash-200gm-3-1654167869.jpg?dim=100x0&dpr=1&q=100",
    img3: "https://cdn01.pharmeasy.in/dam/products_otc/I07034/fash-x-gel-face-wash-200gm-7-1654168030.jpg?dim=100x0&dpr=1&q=100",
    mrp: 350,
    strike: 475,
    discount: 35,
    ancestor: [
      "All Categories",
      "Skin Care",
      "Skin Creams & Hair Removal",
      "Face Wipes",
    ],
    brand: "N/A",
    instock: true,
  },
];